import { bind } from '@react-rxjs/core'
import { map } from 'rxjs'

import { latestDispensaryOrDefaultValues$ } from './useDispensaryOrDefaultValues'

export const [useDispensaryIsContactFilled, latestDispensaryIsContactFilled$] = bind(
  latestDispensaryOrDefaultValues$.pipe(
    map((result) => {
      if (result._tag === 'Left') return false

      const { contact } = result.data
      return Boolean(contact?.specialties?.length) && Boolean(contact?.image?.asset._ref)
    }),
  ),
)
